



























import type { Comment } from '@getaccept/lib-shared/src/contextual-comments/types/comment';
import { AvatarSize } from '@getaccept/lib-ui';
import type { PropType, Ref } from '@vue/composition-api';
import { computed, nextTick, defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import debounce from 'debounce';
import type { CommentParticipantDetails } from '../types/comment-participant-details';
import { CommentStatus } from '../types/comment-status';
import type { UpdateCommentDto } from '../types/update-comment-dto';
import CommentInput from './CommentInput.vue';
import MessageContainer from './MessageContainer.vue';

export default defineComponent({
  name: 'ConversationCard',
  components: {
    CommentInput,
    MessageContainer,
  },
  props: {
    comment: {
      type: Object as PropType<Comment>,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    participantDetails: {
      type: Object as PropType<CommentParticipantDetails>,
      default: () => ({ name: '', thumbUrl: '' }),
    },
  },
  setup(props, { emit }) {
    const commentInput: Ref<InstanceType<typeof CommentInput> | null> = ref(null);

    const commentCard = ref(null);

    const setFocus = () => {
      if (props.selected) {
        commentInput.value.setFocus();
      }
    };

    const isDraft = computed(() => props.comment.status === CommentStatus.Draft);

    // TODO should also check that comment is createdBy current user
    const isResolvable = computed(() => props.comment.status === CommentStatus.Active);

    const textValue = computed(() => {
      if (isDraft.value) {
        return props.comment.text || '';
      }
      return '';
    });

    watch(() => props.selected, setFocus);

    onMounted(async () => {
      await nextTick();
      emit('height', { commentId: props.comment.id, height: commentCard.value.$el.offsetHeight });
    });

    const emitText = (text: string) => {
      const payload: Partial<UpdateCommentDto> = { text };
      emit('update', payload);
    };

    const handleResolve = () => {
      const payload: Partial<UpdateCommentDto> = { status: CommentStatus.Resolved };
      emit('update', payload);
    };

    const handleSubmit = (text: string) => {
      if (isDraft.value) {
        emitTextDebounce.clear();
        const payload: Partial<UpdateCommentDto> = { text, status: CommentStatus.Active };
        emit('update', payload);
      } else {
        console.log('creating new reply', text);
      }
    };

    const emitTextDebounce = debounce(emitText, 300);

    return {
      AvatarSize,
      commentCard,
      commentInput,
      CommentStatus,
      emitTextDebounce,
      handleResolve,
      handleSubmit,
      isDraft,
      isResolvable,
      textValue,
    };
  },
});
